import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from 'react'
import * as THREE from 'three'

export interface MapVizCameraType {
  // camera associated with scene
  camera: React.RefObject<THREE.PerspectiveCamera | undefined> | undefined
  setCamera: Dispatch<
    SetStateAction<
      React.RefObject<THREE.PerspectiveCamera | undefined> | undefined
    >
  >
}

export const MapVizCameraContext = createContext<MapVizCameraType | undefined>(
  undefined
)

export const MapVizCameraContextProvider: React.FC<
  MapVizCameraType & { children: ReactNode }
> = ({ children, ...props }) => {
  return (
    <MapVizCameraContext.Provider value={props}>
      {children}
    </MapVizCameraContext.Provider>
  )
}

export const useMapVizCameraContext = () => {
  const context = useContext(MapVizCameraContext)
  if (!context)
    throw new Error(
      'useMapVizCameraContext() must be used within MapVizCameraContext'
    )
  return context
}
